import {Main} from '../../components/main/main.tsx';
import {Page} from '../../components/page/page.tsx';
import {PageContent} from '../../components/page/page_content.tsx';
import {Hero} from '../../components/hero/hero.tsx';
import {NewsDetailsItem} from './news_details_item.tsx';
import {useAppSelector} from '../../store/store.ts';
import {useParams} from 'react-router-dom';

export function NewsDetails() {
    const newsData = useAppSelector((state) => state.news);
    const params = useParams<'newsId'>();
    const newsId = parseInt(params.newsId ?? '-1', 10);

    const newsArticle = newsData.news?.find((article) => article?.id === newsId);
    if (!newsArticle || !newsData.news) {
        return null;
    }
    const articleIndex = newsData.news?.indexOf(newsArticle);
    let nextArticleId = null;
    let previousArticleId = null;
    if (articleIndex !== undefined && articleIndex !== -1 && articleIndex !== null) {
        const nextArticleIndex = articleIndex + 1;
        const nextArticle = newsData.news[nextArticleIndex];
        nextArticleId = nextArticle?.id ?? null;

        const previousArticleIndex = articleIndex - 1;
        const previousArticle = newsData.news[previousArticleIndex];
        previousArticleId = previousArticle?.id ?? null;
    }

    return (
        <Main>
            <Hero url={newsArticle.image} />
            <Page>
                <PageContent>
                    <NewsDetailsItem
                        newsItem={newsArticle}
                        previousArticleId={previousArticleId}
                        nextArticleId={nextArticleId}
                    />
                </PageContent>
            </Page>
        </Main>
    );
}
